import React from 'react'; // No useState needed here anymore
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box, Typography } from '@mui/material';

// 1. Accept props from the parent
export default function RichtextEditor({ value, onChange }) {
  return (
    <Box sx={{ width: '100%' }}>
      {/* <Typography variant="h6" gutterBottom>
        Description
      </Typography> */}

      <Box
        sx={{
          '& .ql-container': {
            minHeight: '150px',
            fontSize: '1rem',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            backgroundColor: '#fff',
          },
          '& .ql-toolbar': {
            backgroundColor: '#f5f5f5',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
          },
          '& .ql-container.ql-snow': {
            borderBottomLeftRadius: '4px',
            borderBottomRightRadius: '4px',
          },
        }}
      >
        <ReactQuill
          theme="snow"
          // 2. Use the props passed down from parent
          value={value}
          onChange={onChange}
          placeholder="Write a message"
        />
      </Box>
    </Box>
  );
}
